export const PAGE_VERTICAL_PADDING = { base: 24, sm: 24, md: 32 }

// TODO: [Responsive] Get it from ui-kit when touch in next time
export const HEADER_HEIGHT = 72
export const MOBILE_HEADER_HEIGHT = 56
